import { createSlice } from "@reduxjs/toolkit";
import { resetStudentAction, studentDailyUsageAction, studentAddToClassAction, studentDeleteAction, studentDetailAction, studentListAction, studentResetPasswordAction, studentShareCollectionAction, studentAddAction, studentAddToteacherClass, SetStudentPasswordAction, multiStudentcreateAction, SetParentPasswordAction, parentListAction, parentDetailAction, parentDailyUsageAction, parentResetPasswordAction, studentEditAction, avatarAction, StudentAvatarAction, parentCreateAction, studentCreateAction, parentEditAction, multiParentcreateAction } from "../Action/studentAction";


const initialState = {
   students:{},
   parents:{},
   studentDetail:{},
   parentDetail:{},
   studentAddToClassStatus:"idle",
   studentResetPasswordStatus:"idle",
   studentDeleteStatus:"idle",
   studentAddStatus:"idle",
   studentCreateStatus:"idle",
   studentShareCollectionStatus:"idle",
   studentAddToteacherStatus:"idle",
   SetStudentPasswordStatus:"idle",
   multiStudentcreateStatus:"idle",
   SetParentPasswordStatus:"idle",
   studentEditActionStatus:"idle",
   parentCreateStatus:"idle",
   multiParentcreateActionStatus:"idle",
   parentResetStatus:"idle",
   parentEditStatus:"idle",
   studentDailyUsage:{},
   parentDailyUsage:{},
   avatars:{}
}

const studentSlice = createSlice({
    name: 'student',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder

            .addCase(studentListAction.fulfilled, (state, action) => {
                state.students = action?.payload?.data;
            })    

            .addCase(studentDetailAction.fulfilled, (state, action) => {
                state.studentDetail = action?.payload?.data;
            })   

            .addCase(parentDetailAction.fulfilled, (state, action) => {
                state.parentDetail = action?.payload?.data;
            })   

            .addCase(parentEditAction.fulfilled, (state, action) => {
                state.parentEditStatus = 'succeeded';
            })    
            
            
            .addCase(studentAddToClassAction.fulfilled, (state, action) => {
                state.studentAddToClassStatus = 'succeeded';
            })   
            
            .addCase(studentResetPasswordAction.fulfilled, (state, action) => {
                state.studentResetPasswordStatus = 'succeeded';
            })   
            
            .addCase(studentDeleteAction.fulfilled, (state, action) => {
                state.studentDeleteStatus = 'succeeded';
            })   

            .addCase(studentDailyUsageAction.fulfilled, (state, action) => {
                state.studentDailyUsage = action?.payload?.data;
            })   

            .addCase(parentDailyUsageAction.fulfilled, (state, action) => {
                state.parentDailyUsage = action?.payload?.data;
            })   

            
            .addCase(parentResetPasswordAction.fulfilled, (state, action) => {
                state.parentResetStatus = action?.payload?.data;
            })   

            
            .addCase(StudentAvatarAction.fulfilled, (state, action) => {
                state.avatars = action?.payload?.data;
            })    
            
            
            .addCase(studentShareCollectionAction.fulfilled, (state, action) => {
                state.studentShareCollectionStatus = 'succeeded';
            })   

            .addCase(studentAddAction.fulfilled, (state, action) => {
                state.studentAddStatus = 'succeeded';
            })   

            .addCase(studentEditAction.fulfilled, (state, action) => {
                state.studentEditActionStatus = 'succeeded';
            })   
            
            .addCase(studentAddToteacherClass.fulfilled, (state, action) => {
                state.studentAddToteacherStatus = 'succeeded';
            })   


            .addCase(parentListAction.fulfilled, (state, action) => {
                state.parents = action?.payload?.data;
            })   

            .addCase(parentCreateAction.fulfilled, (state, action) => {
                state.parentCreateStatus = 'succeeded';
            })    
            .addCase(studentCreateAction.fulfilled, (state, action) => {
                state.studentCreateStatus = 'succeeded';
            })    
            

            .addCase(SetStudentPasswordAction.fulfilled, (state, action) => {
                state.SetStudentPasswordStatus = 'succeeded';
            })   

            .addCase(multiStudentcreateAction.fulfilled, (state, action) => {
                state.multiStudentcreateStatus = 'succeeded';
            })   

 .addCase(multiParentcreateAction.fulfilled, (state, action) => {
                state.multiParentcreateActionStatus = 'succeeded';
            })   


            
            .addCase(SetParentPasswordAction.fulfilled, (state, action) => {
                state.SetParentPasswordStatus = 'succeeded';
            })   


            
            .addCase(resetStudentAction, () => initialState);
            
            
    },
});

export default studentSlice.reducer;




